import React, { useState } from "react";
import { useToast } from "../../store/ToastProvider";
import { NavBar } from "../../components/common/NavBar";
import { SideMenu } from "../../components/common/SideMenu";
import { FeatureCard } from "../../components/common/FeatureCard";
import { reportsListDefaultItems, bgImages } from "./reportsConfig";
import { CreateReportModal } from "./CreateReportModal";
import {
  BackgroundContainer,
  MainColumn as Column,
  NavBarContainer,
  RowContainer,
} from "../../components/containers/styledComponents";
import {
  CompassMainHeader,
  CompassParagraph,
} from "../../components/common/styledComponents";
import { MESSAGES } from "../../messages";
import { greyText } from "../../styles";
import { ReportItem } from "./reportsConfig";
import { ReportCategory } from "../../enums/Reports";

export const ReportsList = (): JSX.Element => {
  const { addToast } = useToast();
  const [show, setShow] = useState<boolean>(false);
  const [showCreateReportModal, setShowCreateReportModal] =
    useState<boolean>(false);
  const [reportType, setReportType] = useState<ReportCategory>(
    ReportCategory.TCFD
  );

  const handleCreateReport = (reportItem: ReportItem): void => {
    setReportType(reportItem.type);
    !reportItem.isActive
      ? addToast(`${reportItem.title} reports blocked`, "warning")
      : setShowCreateReportModal(true);
  };

  return (
    <BackgroundContainer>
      <Column flex={show ? "0 0 15%" : "0 0 0%"} show={show}>
        <SideMenu show={show} setShow={setShow} />
      </Column>
      <Column flex="1" bg="#F5F5F5" overflow={true}>
        <NavBarContainer>
          <RowContainer mt={1} mb={1}>
            <NavBar address={"reports-list"} />
          </RowContainer>
          <RowContainer ai={"flex-start"} jc={"flex-start"} mt={-15}>
            <CompassMainHeader pt={1} ml={12}>
              Reports List
            </CompassMainHeader>
          </RowContainer>
          <RowContainer ai={"flex-start"} jc={"flex-start"} mt={1}>
            <CompassParagraph ml={12} color={greyText}>
              {MESSAGES.REPORTS_LIST_DESCRIPTION}
            </CompassParagraph>
          </RowContainer>
        </NavBarContainer>
        <RowContainer ai={"flex-start"} jc={"flex-start"} wrap="wrap">
          {reportsListDefaultItems.map((item, index) => {
            return (
              <FeatureCard
                key={index}
                item={{
                  ...item,
                  bg: item.bg || bgImages[index % bgImages.length],
                }}
                buttonText="Create"
                variant="report"
                colorIndex={item.colorIndex}
                onClick={(): void => handleCreateReport(item)}
              />
            );
          })}
        </RowContainer>
      </Column>
      <CreateReportModal
        show={showCreateReportModal}
        handleClose={(): void => setShowCreateReportModal(false)}
        reportType={reportType}
      />
    </BackgroundContainer>
  );
};
